import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  constructor(readonly modalService: NgbModal) {}

  public confirm(
    title: any,
    message: string,
    btnOkText: string = '',
    btnCancelText: string = '',
    buttonAlignClass: string = 'justify-content-center'
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmDialogComponent, {
      windowClass: 'confirm-dialog',

      centered: true,
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.btnOkText = btnOkText;
    modalRef.componentInstance.btnCancelText = btnCancelText;
    modalRef.componentInstance.buttonAlignClass = buttonAlignClass;
    return modalRef.result;
  }
}
